import { render } from "./Cadastro.vue?vue&type=template&id=163695a8&ts=true"
import script from "./Cadastro.vue?vue&type=script&lang=ts"
export * from "./Cadastro.vue?vue&type=script&lang=ts"

import "./Cadastro.vue?vue&type=style&index=0&id=163695a8&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__